<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="QuotationTaskCloseTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_filter="true" :show_close="true" :show_close_cancel="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy"
        :table_height_adjust="-6" :loading_width="40" :hb_table_class="'hb_table_qttable_close_class1'"
        @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]" only_text="显示全部" @only_methods="only_methods"
        @state_change="state_change">
        <template #query>
          <el-select v-model="date_type" placeholder="" size="small" style="width: 100px">
            <el-option label="创建日期" value="date1"></el-option>
          </el-select>
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          报价申请单号：
          <el-select size="small" v-model="QuotationTaskNum" filterable remote reserve-keyword
            :remote-method="getKvQuoteTask" clearable @clear="getKvQuoteTask('')" @focus="getKvQuoteTask('')"
            placeholder="请输入报价申请编号关键词" class="w-10">
            <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
          </el-select>
          物料编号：<el-input clearable size="small" style="width: 150px" v-model="ItemId"></el-input>
        </template>
        <template #toolbar>
          <el-popover placement="right" title="提示" width="300" trigger="hover" style="border-color: red;">
            <p>1、暂无操作数据可能是因为您没有勾选;</p>
            <p>2、默认显示未处理的关闭申请;</p>
            <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
          </el-popover>
        </template>
      </TableMain>
    </BaseContainer>

  </div>
</template>

<script>
import { addMonths } from "date-fns";
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController";
import * as SalesOrderController from "../../controllers/sd/SalesOrderController";
import BaseContainer from "../components/BaseContainer";
import QueryButton from "../components/base/QueryButton";
import TableMain from "../components/table/TableMain";

export default {
  components: {
    BaseContainer,
    TableMain,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
      },
      fields: _.cloneDeep(QuotationTaskController.fields.quote_order_close),
      QuotationTaskNum: "",
      ItemId: "",
      QTOptions: [],
      all_role_users: [],
      isBusy: false,
      date_type: "date1",
      date_range: "",
    };
  },
  async created() {
    await this.getAllRoleUsers();
    const start = addMonths(new Date(), -6);
    const end = new Date();
    this.date_range = [start, end];
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName();
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0];
      }
    },
    //#region 查询
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true;
        set_data([]);
      }
      let _fromDate = "", _toDate = "";
      let p = {};
      if (!_.isNull(this.date_range) && this.QuotationTaskNum == "" && this.ItemId == "") {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd");
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd");
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        );
        p["create_date_from"] = _fromDate;
        p["create_date_to"] = _toDate;
      }
      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = this.QuotationTaskNum;
      }
      if (this.ItemId != "") {
        p.ItemId = this.ItemId
      }
      let _result = await QuotationTaskController.methods.getQuoteCloseApplication(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["id"], ["desc"])
        if (!this.$refs.QuotationTaskCloseTable1.only_value)
          dt = _.filter(dt, { closed: 1 });
        set_data(dt);
      }
      this.isBusy = false;
    },
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv");
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum };
        });
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    //#endregion
    async only_methods() {
      await this.on_query(this.$refs.QuotationTaskCloseTable1.SetData, false);
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
    async state_change(data, cb) {
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        cb(false);
        return;
      }
      //报价明细上的closed:0--正常，1--待关闭，2--已关闭
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      if (data.state == "closed") {
        let _result = await QuotationTaskController.methods.excuteQuoteCloseApplication(data.selected_items);
        if (!_.isNull(_result) && _result && _result.length > 0) {
          await this.on_query(this.$refs.QuotationTaskCloseTable1.SetData, false);
          this.msgToasts(this.$t("notify.action_successfully"), "success");
        }
        else
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
      }
      else if (data.state == "cancel_closed") { ///撤销关闭
        let wait_close_data = _.filter(data.selected_items, (t) => t.closed == 1)
        if (wait_close_data.length == 0) {
          this.msgToasts("暂无待关闭数据！", "info");
          return
        }
        //检查是否已经关闭
        let closed_data = await QuotationTaskController.methods.getDetailData(_.map(data.selected_items, (t) => { return { id: { "=": t.QuotationTaskDetailId }, closed: { "=": 2 } } }))
        if (!_.isNull(closed_data) && closed_data && closed_data.length > 0 && closed_data[0].length > 0) {
          this.msgToasts("报价已被销售关闭，请重新查询再执行该操作！", "info");
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"));
        if (v) {
          let _result = await QuotationTaskController.methods.cancelQuoteCloseApplication(_.map(data.selected_items, (t) => { return { QuotationTaskDetailId: t.QuotationTaskDetailId } }));
          if (!_.isNull(_result) && _result && _result.length > 0) {
            await this.on_query(this.$refs.QuotationTaskCloseTable1.SetData, false);
            this.msgToasts(this.$t("notify.action_successfully"), "success");
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        }
      }
      cb(false)
    }
  },
};
</script>
<style>
.hb_table_qttable_close_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 220rem;
}
</style>
